import request from '@/router/axios'
//查询企业所有发票地址
export function getAllInvoiceAddress(query) {
  return request({
    url: '/companyAddress/getAllInvoiceAddress',
    method: 'post',
    params: query
  })
}

//获取企业发票信息
export function getCompanyInvoiceInfo(query) {
  return request({
    url: '/companyInvoice/getCompanyInvoiceInfo',
    method: 'post',
    params: query
  })
}

//修改发票信息
export function updateCompanyInvoiceInfo(query) {
  return request({
    url: '/companyInvoice/updateCompanyInvoiceInfo',
    method: 'post',
    params: query
  })
}

//添加发票地址
export function addInvoiceAddress(query) {
  return request({
    url: '/companyAddress/addInvoiceAddress',
    method: 'post',
    params: query
  })
}

//获取企业默认发票地址
export function getDefaultInvoiceAddress(query) {
  return request({
    url: '/companyAddress/getDefaultInvoiceAddress',
    method: 'post',
    params: query
  })
}

//修改发票默认地址
export function updateDefaultAddress(query) {
  return request({
    url: '/companyAddress/updateDefaultAddress',
    method: 'post',
    params: query
  })
}

//修改发票地址
export function updateInvoiceAddress(query) {
  return request({
    url: '/companyAddress/updateInvoiceAddress',
    method: 'post',
    params: query
  })
}


//删除发票地址
export function deleteAddress(query) {
  return request({
    url: '/companyAddress/deleteAddress',
    method: 'post',
    params: query
  })
}

//平台发票管理列表
export function projectInvoice(query) {
  return request({
    url: '/projectInvoice/',
    method: 'post',
    params: query
  })
}

//发票申请
export function addInvoice(query) {
  return request({
    url: '/projectInvoice/addInvoice',
    method: 'post',
    params: query
  })
}

//企业发票数统计
export function getCompanyInvoiceCount(query) {
  return request({
    url: '/projectInvoice/getCompanyInvoiceCount',
    method: 'post',
    params: query
  })
}

//平台发票数统计
export function getInvoiceCount(query) {
  return request({
    url: '/projectInvoice/getInvoiceCount',
    method: 'post',
    params: query
  })
}

//发票详情
export function getProjectDetail(query) {
  return request({
    url: '/projectInvoice/info',
    method: 'post',
    params: query
  })
}

//平台邮寄发票，添加快递单号和快递名称
export function updateInvoiceExpress(query) {
  return request({
    url: '/projectInvoice/updateInvoiceExpress',
    method: 'post',
    params: query
  })
}

//平台开发票，添加发票编号
export function updateInvoiceNum(query) {
  return request({
    url: '/projectInvoice/updateInvoiceNum',
    method: 'post',
    params: query
  })
}
